<template>
  <OverviewCard :title="$t('key_dashboard_alerts')" :loading="loading" :error="error">
    <component
      :is="alert.path ? 'a' : 'div'"
      v-for="alert in rows"
      :key="alert.key"
      class="alert-row"
      :class="{ 'cursor-pointer': alert.path }"
      :style="{ borderColor: tone(alert).color, backgroundColor: tone(alert).tint }"
      @click="open(alert)"
    >
      <span class="d-flex align-items-center text-xs">
        <i class="fa me-2" :class="tone(alert).icon" :style="{ color: tone(alert).color }" aria-hidden="true"></i>
        {{ $t(alert.label) }}
      </span>
      <span class="text-sm font-weight-bold">{{ format(counter(alert).count) }}</span>
    </component>
  </OverviewCard>
</template>

<script>
import OverviewCard from "./OverviewCard.vue";
import { COLORS, formatNumber } from "./shared";

// The back decides the level of each counter; the front only picks its look.
const TONES = {
  ok: { color: COLORS.greenMid, tint: COLORS.greenTint, icon: "fa-circle-check" },
  warning: { color: COLORS.yellow, tint: COLORS.yellowTint, icon: "fa-triangle-exclamation" },
  critical: { color: COLORS.red, tint: COLORS.redTint, icon: "fa-hand" },
};
const NOT_REGISTERED = { status: "NO_REGISTRADO" };

// The counters cover the last 90 days, whatever the selected period. Each one
// opens its listing filtered by status. The back also returns
// shipments_without_tracking, but that alert is disabled for now.
const ALERTS = [
  { key: "products_not_registered", label: "key_dashboard_alert_products", path: "/MasterData/Products" },
  { key: "orders_not_registered", label: "key_dashboard_alert_orders", path: "/Operations/Orders" },
  { key: "purchases_not_registered", label: "key_dashboard_alert_purchases", path: "/Operations/Purchases" },
  { key: "orders_back_not_registered", label: "key_dashboard_alert_orders_back", path: "/Operations/Ordersback" },
];

export default {
  name: "OverviewAlerts",
  components: { OverviewCard },
  props: {
    data: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
    error: { type: [Object, Error, String], default: null },
  },
  data() {
    return { rows: ALERTS };
  },
  methods: {
    open(alert) {
      if (alert.path) {
        this.$router.push({ path: alert.path, query: NOT_REGISTERED });
      }
    },
    counter(alert) {
      return this.data[alert.key] || {};
    },
    tone(alert) {
      return TONES[this.counter(alert).level] || TONES.ok;
    },
    format(value) {
      return formatNumber(value, this.$i18n.locale);
    },
  },
};
</script>

<style scoped>
.alert-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 0.85rem;
  margin-bottom: 0.7rem;
  border: 1px solid;
  border-radius: 0.5rem;
  color: inherit;
}
</style>
